// Согласование числа с существительным. Подпись над списком обязана звучать по-русски:
// «1 объект», «2 объекта», «5 объектов» (ПРАВИЛА.md, правило 2 — над списком написано, что
// перечислено и сколько). «5 объект» читается как поломка, а не как число.

/** Неразрывный пробел: число и слово не разъезжаются по строкам. */
const NBSP = '\u00a0';

/** Формы: [1 объект, 2 объекта, 5 объектов]. */
export type PluralForms = readonly [string, string, string];

export function pluralRu(count: number, forms: PluralForms): string {
  const abs = Math.abs(Math.trunc(count));
  const lastTwo = abs % 100;
  const last = abs % 10;
  if (lastTwo >= 11 && lastTwo <= 14) {
    return forms[2];
  }
  if (last === 1) {
    return forms[0];
  }
  if (last >= 2 && last <= 4) {
    return forms[1];
  }
  return forms[2];
}

/** «281 человек», «74 заявки». Число и слово склеены неразрывным пробелом. */
export function countLabel(count: number, forms: PluralForms): string {
  return `${count}${NBSP}${pluralRu(count, forms)}`;
}
